import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import { ArrowRight as k, CloseX24 as _ } from "@hagerty/icons";
import r from "clsx";
import e, { useContext as v, useEffect as t } from "react";
import { PrimaryNavContext as u } from "./PrimaryNavContext";

var N = function N() {
  var _v = v(u),
      o = _v.isBreakpointWithMenu,
      i = _v.isDesktopMenuOpen,
      n = _v.setIsDesktopMenuOpen,
      s = _v.menuData,
      m = _v.setActiveFlyout,
      p = _v.handleFlyoutClose,
      l = function l() {
    n(!1);
  };

  return t(function () {
    o && n(!1);
  }, [o, n]), t(function () {
    var a = function a(d) {
      d.key === "Escape" && i && (n(!1), m(null), p());
    };

    return document.addEventListener("keydown", a), function () {
      document.removeEventListener("keydown", a);
    };
  }, [i, n, m, p]), i && e.createElement("div", {
    id: "hg-primarynav-desktop-menu",
    className: "hg-primarynav__desktop-flyout"
  }, e.createElement("div", {
    className: "hg-primarynav__desktop-flyout-container"
  }, (s == null ? void 0 : s.primaryLinks) && e.createElement("div", {
    className: "hg-primarynav__desktop-menu--elevated"
  }, e.createElement("h2", {
    className: "hg-primarynav__menu-header"
  }, "Services"), s.primaryLinks.map(function (a) {
    return e.createElement("div", {
      key: a.id,
      className: r("hg-primarynav__desktop-item", "hg-primarynav__desktop-item--".concat(a.name.toLowerCase()), "hg-primarynav__desktop-item--menu")
    }, e.createElement("ul", {
      className: "hg-primarynav__desktop-menu-group"
    }, e.createElement("li", {
      className: "hg-primarynav__desktop-list-item"
    }, e.createElement("a", {
      href: a.url,
      className: r("hg-primarynav__desktop-menu-link", "hg-primarynav__desktop-menu-link--".concat(a.name.toLowerCase()))
    }, e.createElement("span", {
      className: "hg-primarynav__desktop-link-text-container"
    }, a.label), e.createElement("span", {
      className: "hg-primarynav__desktop-link-chevron"
    }, e.createElement(k, null))))));
  })), (s == null ? void 0 : s.quickLinks) && e.createElement("div", {
    className: "hg-primarynav__desktop-menu--base"
  }, e.createElement("h2", {
    className: "hg-primarynav__menu-header"
  }, "Quick Links"), s.quickLinks.map(function (a) {
    return e.createElement("div", {
      key: a.id,
      className: r("hg-primarynav__desktop-item", "hg-primarynav__desktop-item--".concat(a.name.toLowerCase()), "hg-primarynav__desktop-item--menu")
    }, e.createElement("ul", {
      className: "hg-primarynav__desktop-menu-group"
    }, e.createElement("li", {
      className: "hg-primarynav__desktop-list-item"
    }, e.createElement("a", {
      href: a.url,
      className: r("hg-primarynav__desktop-menu-link", "hg-primarynav__desktop-menu-link--".concat(a.name.toLowerCase()))
    }, e.createElement("span", {
      className: "hg-primarynav__desktop-link-text-container"
    }, a.label)))));
  }))), e.createElement("button", {
    onClick: l,
    type: "button",
    className: "hg-primarynav__desktop-menu-close-button"
  }, e.createElement(_, {
    width: "20",
    height: "20"
  })));
};

export { N as DesktopFlyout };